(() => {
  if (customElements.get('pistacho-mobile-nav')) return;
  customElements.define('pistacho-mobile-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const tabs = [...this.querySelectorAll('[data-pmnav-tab]')];
      const panels = [...this.querySelectorAll('[data-pmnav-panel]')];
      const select = (world, focus = false) => {
        tabs.forEach(tab => {
          const active = tab.dataset.pmnavTab === world;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => {
          panel.hidden = panel.dataset.pmnavPanel !== world;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', `${panel.id.replace(/-(loja|decor)$/, '')}-tab-${panel.dataset.pmnavPanel}`);
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.pmnavTab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next].dataset.pmnavTab, true);
        });
      });
      select(this.dataset.inicio || 'loja');
      this.setAttribute('data-ready', '');
      this.querySelector('[role="tablist"]').hidden = false;
    }
  });
})();
